import { post } from "./request";
import userInfo from './states/userinfo'

export function getUserInfo() {
    return post("/?service=myheroAnniversary2023&api=getInfo")
}

export function sendCode(phone) {
    return post("/?service=sms&api=send", {
        "phone": phone,
        "type": 4
    }, false)
}

export function login(phone, verify) {
    return post("/?service=myheroAnniversary2023&api=login", {
        "phone": phone,
        "verify": verify
    }, false)
}

export function getServerListReturn(isTest) {
    return post("/?service=myheroAnniversary2023&api=getServerListReturn", {
        "isTest": isTest
    })
}

export function bind(bindRid, serverId) {
    return post("/?service=myheroAnniversary2023&api=bind", {
        "bindRid": bindRid,
        "serverId": serverId
    })
}

export function checkBindReq(bindRid, serverId) {
    return post("/?service=myheroAnniversary2023&api=checkBind", {
        "bindRid": bindRid,
        "serverId": serverId
    })
}

export function setUserInfo(ret) {
    userInfo.isLogin = true
    userInfo.isBind = ret.isBind
    userInfo.lastGameRid = ret.lastGameRid == 0 ? "" : ret.lastGameRid
    userInfo.lastServerId = ret.lastServerId
    userInfo.userId = ret.data
    userInfo.token = ret.token
}

export function saveToken(token) {
    localStorage.setItem('4th_token', token)
}

export function getToken() {
    return localStorage.getItem('4th_token')
}

export function clearToken() {
    localStorage.removeItem('4th_token')
}

export function saveMobile(mobile) {
    mobile = mobile.replace(/(\d{3})\d{6}(\d{2})/, '$1 ****** $2')
    localStorage.setItem('4th_mobile', mobile)
}

export function getMobile() {
    return localStorage.getItem('4th_mobile')
}

export function getTimeList() {
    return post("/?service=myheroAnniversary2023&api=getTimeList")
}